export default "__VITE_ASSET__D_rASAV9__"